<template>
  <div class="home-wrapper">
    <Header type="transparent"></Header>
    <Slider />
    <Footer />
  </div>
</template>

<script>
import AOS from "aos";
import Header from "../components/common/Header.vue";
import Slider from "../components/home/Slider.vue";
import Footer from "../components/common/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Slider,
    Footer
  },
  mounted() {
    AOS.init({ once: false });
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        try {
          document.title = this.$t("home.title") || "BAU Innovation and Consultancy Inc.";
        } catch (e) {
          document.title = "BAU Innovation and Consultancy Inc.";
        }
      },
    },
  },
};
</script>